import { Box } from '@mui/material';
import { useMaterialUIController } from 'context';
import { getCrmColors } from '../../crm-theme';
import { tagChipSx, tagDotSx } from './crm-tag-chip.styles';

interface Props {
    name: string;
    color: string;
    /// Menor, para o card do quadro.
    compact?: boolean;
}

/// Etiqueta de tag, usada no lead e nas configurações de tags.
export const CrmTagChip = ({ name, color, compact = false }: Props) => {
    const [controller] = useMaterialUIController();
    const cc = getCrmColors(controller.darkMode);

    return (
        <Box component="span" sx={tagChipSx(cc, color, compact)}>
            <Box component="span" sx={tagDotSx(color)} />
            <Box component="span" sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {name}
            </Box>
        </Box>
    );
};
